
import { Base } from '../base-component';
import { MapService } from '../../services/map.service';

import './map.component.scss';

export class Map extends Base {

	map: google.maps.Map;
	mapOptions: google.maps.MapOptions;
	mapConfig: google.maps.MapOptions;
	userOptions: any;
	mapUrl: string;
	APIKey: string;

	constructor(element: Element) {

		super(element);

		new MapService().init();

		this.event.register('googleMapsReady', null, this.initMap.bind(this));

	}

	init() {

		this.userOptions = JSON.parse(this.element.getAttribute('data-config'));

		this.mapOptions = {

			backgroundColor: '#FFF',
			center: {
				lat: -26.115976,
				lng: 28.046638
			},
			clickableIcons: true,
			draggable: true,
			fullscreenControl: true,
			gestureHandling: 'cooperative',
			scrollwheel: true,
			styles: [
				{
					elementType: 'geometry',
					featureType: 'water',
					stylers: [
						{
							color: '#00BDBD'
						}
					]
				},
				{
					elementType: 'geometry',
					featureType: 'landscape.man_made',
					stylers: [
						{
							color: '#f7f1df'
						}
					]
				}
			],
			zoom: 4
		};

	}

	bindEvents() {}

	initMap() {

		this.mapConfig = Object.assign(
			this.mapOptions,
			this.userOptions.config
		);

		this.map = new google.maps.Map(
			this.element,
			this.mapConfig
		);

		google.maps.event.addDomListener(window, 'resize', () => this.map.setCenter(this.userOptions.center));

		this.event.emit('mapInitialised', {
			map: this.map,
			options: this.userOptions
		});

	}

}



// WEBPACK FOOTER //
// ./components/map/map.component.ts